define([
    "dojo/_base/declare",
    "Apparel/ProductSalesRegionSwitchboard"
], function(declare,ProductSalesRegionSwitchboard) {
    
    return declare(ProductSalesRegionSwitchboard, {
        
        canShowPlugin: function() {
            // summary: disable the view if PriceList has blank in PriceForSalesRegionOrCountry
            var view = this.getView();
            var priceListRev = view.getViewNode();
            var priceList = view.getCache().getNode(priceListRev.__Parent__);
            
            if (priceList && priceList.PriceForSalesRegionOrCountry == "PriceForSalesRegionOrCountry:") {
                return false;
            }
            return this.inherited(arguments);
        }
        
    });
});